// Shipping weight + rate STUBS — configurator step 12.
//
// The portal performs ZERO shipping math. Package weight and the carrier
// rate are computed by Nexus / the carrier as a follow-up (carrier
// integration + rate-shopping is a separate, not-yet-built surface). These
// typed boundaries exist so:
//   1. the UI can show a clearly-marked "calculated separately" placeholder
//      WITHOUT ever fabricating a number, and
//   2. the eventual real implementation — a Nexus call, NOT portal math — has
//      a stable signature to slot into.
//
// Shipping cost is NEVER folded into total_sale_amount. The charged total is
// total_sale_amount + tax_amount + shipping, where shipping is its own figure
// (ADR-010 §12). Until the follow-up lands, that figure is this placeholder.

// `estimated: false` is the load-bearing marker: callers must treat the
// numeric fields as "not known yet" and render the `reason`, never a number.
export type WeightEstimate = {
  estimated: false;
  weight_oz: null;
  reason: string;
};

export type ShippingRateEstimate = {
  estimated: false;
  amount: null;
  currency: string | null;
  service: string | null;
  reason: string;
};

// Position-neutral wording (shown on more than one surface): never implies
// the figure is in the priced subtotal.
const STUB_REASON =
  'Calculated by Argo and your carrier when we finalize your order. Billed separately, and never part of the price you see here.';

// Inputs are intentionally open-ended: the follow-up will read the priced
// projects[] + packaging to estimate weight. Today it returns a placeholder
// and computes nothing.
export function estimateShipmentWeight(_input?: {
  // e.g. { lines: QuoteLineDto[] } — supplied by the Nexus/carrier follow-up.
  [key: string]: unknown;
}): WeightEstimate {
  return { estimated: false, weight_oz: null, reason: STUB_REASON };
}

// The follow-up will pass destination + weight + service to a Nexus/carrier
// rate lookup. Today it returns a placeholder and computes nothing.
export function lookupShippingRate(_input?: {
  // e.g. { destination: ShipTo, weight: WeightEstimate, service: string }.
  [key: string]: unknown;
}): ShippingRateEstimate {
  return {
    estimated: false,
    amount: null,
    currency: null,
    service: null,
    reason: STUB_REASON,
  };
}
